<!-- 
Shows a chip for each search criteria.

Chips can be clicked to bring up the search dialog with the criteria focussed.
Chips have a "clear" button which can be clicked to clear the corresponding search criteria.
-->
<template>
  <span>
    <v-chip 
      v-for="(chip, i) in chips" 
      :key="`chip=${i}`" 
      close 
      @click="select(chip.filter)"
      @input="clear(chip.filter)"
    >
      {{ getDescription(chip) }}
    </v-chip>
  </span>
</template>

<script>
import _ from "underscore";
import * as formatting from "@/helpers/formatting.helper";
import {
  FILTER_TYPE_INTEGER,
  FILTER_TYPE_MULTISELECT,
  FILTER_TYPE_YESNO,
  FILTER_TYPE_SELECT,
  FILTER_TYPE_DATE,
  FILTER_TYPE_DATETIME,
  FILTER_TYPE_SWITCH
} from "@/store/system/helpers";
import { SAVED_SEARCHES_PRESELECTED_FILTER } from "@/store/searches/mutation-types";

export default {
  props: {
    criteria: {
      type: Object,
      required: true
    },
    criteriaMutation: {
      type: String,
      required: true
    },
    searchFilters: {
      type: Array,
      required: true
    }
  },
  computed: {
    chips() {
      const filters = _(this.allFilters).filter(f => this.hasCriteria(f));
      return _(filters).map(f => ({ filter: f, description: this.getCriteriaDescription(f) }));
    },
    allFilters() {
      if (this.isExpander) {
        return _(_(this.searchFilters).map(f => f.children)).flatten();
      } else {
        return _(this.searchFilters).filter(f => f.value);
      }
    },
    isExpander() {
      return !!_(this.searchFilters).first().children;
    }
  },
  methods: {
    hasCriteria(filter) {
      const c = this.criteria[filter.value];
      switch (filter.type) {
        case FILTER_TYPE_MULTISELECT:
          if (!c) console.error(`Expected criteria.${filter.value} to be an array`);
          return c.length > 0;
        case FILTER_TYPE_YESNO:
        case FILTER_TYPE_SELECT:
          return c != null;
        default:
          return !!c;
      }
    },
    getCriteriaDescription(filter) {
      const value = this.criteria[filter.value];
      if (filter.type == FILTER_TYPE_YESNO) return value ? "Yes" : "No";
      if (filter.type == FILTER_TYPE_SELECT) return _(filter.items).find(o => o.value == value).text;
      if (filter.type == FILTER_TYPE_MULTISELECT) {
        const descriptions = _(value).map(v => `'${_(filter.items).find(i => i.value == v).text}'`);
        return descriptions.join(" or ");
      }
      if (filter.type == FILTER_TYPE_DATE) return formatting.compactDate(value);
      if (filter.type == FILTER_TYPE_DATETIME) return formatting.compactDateOrDateTime(value);
      if (filter.type == FILTER_TYPE_INTEGER) return value;
      return `'${value}'`;
    },
    clear(filter) {
      const empty = filter.type == FILTER_TYPE_MULTISELECT ? [] : null;
      this.$store.commit(this.criteriaMutation, { [filter.value]: empty });
      this.$emit("changed");
    },
    select(filter) {
      this.$store.commit(SAVED_SEARCHES_PRESELECTED_FILTER, filter);
    },
    getDescription(chip) {
      return chip.filter.type == FILTER_TYPE_SWITCH ? chip.filter.text : `${chip.filter.text}: ${chip.description}`;
    }
  }
};
</script>
